import React, { useState } from 'react';
import { Icon } from '@/components/shared/display/Icon';
import { CopyIcon, CheckIcon } from '@/assets/Icons';
import { BaseButton } from '../Button';

interface CopyButtonProps {
  text: string;
}

export function CopyButton({ text }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 500);
  };

  return (
    <BaseButton
      onClick={handleCopy}
      variant="ghost"
      size="icon"
      className="p-0"
      icon={
        copied ? (
          <Icon icon={CheckIcon} className="text-healthy" />
        ) : (
          <Icon icon={CopyIcon} className="text-neutral-100" />
        )
      }
    />
  );
}
